<agr-form-dialog [formGroup]="formGroup" (confirm)="confirm()" (cancel)="cancel()" [data]="data">
  <ng-container class="table-container">
    <mat-table [dataSource]="datasource" data-test="barn-distribution-table">
      <ng-container matColumnDef="productTitle">
        <mat-header-cell *matHeaderCellDef>{{ 'balance.product' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" data-test="barn-distribution-table__productTitle">
          {{ element.productTitle }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="consumptionWithinCycle">
        <mat-header-cell *matHeaderCellDef class="cell--align-right">
          {{ 'balance.consumption' | translate }}
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element; let i = index"
          class="cell--align-right"
          data-test="barn-distribution-table__consumptionWithinCycle"
        >
          {{ getConsumptionWithinCycle(element, i) | agrNumber }}
        </mat-cell>
      </ng-container>

      <ng-container *ngFor="let barn of barns" [matColumnDef]="barn.name">
        <mat-header-cell *matHeaderCellDef class="cell--align-right">
          {{ barn.name }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="cell--align-right">
          <mat-form-field class="amount spacing--margin-half-top" subscriptSizing="dynamic">
            <mat-label>{{ 'balance.barn-distribution.usage-in-kg' | translate }}</mat-label>
            <input
              [disabled]="disableBarnsEditing(element, barn)"
              [attr.data-test]="'barn-distribution-table__barn__' + barn.name"
              matInput
              agrNumber
              placeholder="{{ 'balance.barn-distribution.usage-in-kg' | translate }}"
              [value]="getBarnQuantity(element, barn)"
              (change)="barnAmountChanged(element, barn, $event)"
            />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container
        *ngFor="let columnName of displayedTotalColumns; let i = index"
        [matColumnDef]="columnName"
      >
        <mat-footer-cell
          [attr.data-test]="'barn-distribution-table__' + columnName"
          *matFooterCellDef
          >{{
            i === 0 ? getFooterValue(columnName, i) : (getFooterValue(columnName, i) | agrNumber)
          }}
        </mat-footer-cell>
      </ng-container>

      <ng-container
        *ngFor="let columnName of displayedTotalRawColumns; let i = index"
        [matColumnDef]="columnName"
      >
        <mat-footer-cell
          [attr.data-test]="'barn-distribution-table__' + columnName"
          *matFooterCellDef
          >{{
            i === 0 ? getFooterValue(columnName, i) : (getFooterValue(columnName, i) | agrNumber)
          }}
        </mat-footer-cell>
      </ng-container>

      <ng-container
        *ngFor="let columnName of displayedTotalCompoundColumns; let i = index"
        [matColumnDef]="columnName"
      >
        <mat-footer-cell
          [attr.data-test]="'barn-distribution-table__' + columnName"
          *matFooterCellDef
          >{{
            i === 0 ? getFooterValue(columnName, i) : (getFooterValue(columnName, i) | agrNumber)
          }}
        </mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'first-row': row.deliverySource === 'start' }"
      ></mat-row>
      <mat-footer-row *matFooterRowDef="displayedTotalColumns"></mat-footer-row>
      <mat-footer-row *matFooterRowDef="displayedTotalRawColumns"></mat-footer-row>
      <mat-footer-row *matFooterRowDef="displayedTotalCompoundColumns"></mat-footer-row>
    </mat-table>
  </ng-container>

  <div
    class="notification notification-error"
    *ngIf="informationData?.consumptionWithinCycle !== currentlyAllocated"
    data-test="barn-distribution-table__amountError"
  >
    <mat-icon>error</mat-icon>
    {{ 'balance.barn-distribution.total-should-be' | translate }}
    {{ informationData?.consumptionWithinCycle }} KG.
    {{ 'balance.barn-distribution.currently' | translate }} {{ currentlyAllocated }} KG
  </div>
</agr-form-dialog>
